import { render, staticRenderFns } from "./ContainerWithoutMenu.vue?vue&type=template&id=699db2ba&"
import script from "./ContainerWithoutMenu.vue?vue&type=script&lang=js&"
export * from "./ContainerWithoutMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699db2ba')) {
      api.createRecord('699db2ba', component.options)
    } else {
      api.reload('699db2ba', component.options)
    }
    module.hot.accept("./ContainerWithoutMenu.vue?vue&type=template&id=699db2ba&", function () {
      api.rerender('699db2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/ContainerWithoutMenu.vue"
export default component.exports